export enum ListingType {
  MINERALS_FOR_SALE = 'minerals_for_sale',
  MINERALS_FOR_LEASE = 'minerals_for_lease',
  ROYALTIES_FOR_SALE = 'royalties_for_sale'
}
